import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaUpload,
  FaExchangeAlt,
  FaListAlt,
  FaSignOutAlt,
  FaChevronDown,
  FaCog,
  FaFileExcel
} from 'react-icons/fa';
import { matchInvoices } from '../services/api';
import { AuthContext } from '../context/AuthContext';
import '../assets/LayoutWithNavbar.css'; // ✅ Fixed path

const LayoutWithNavbar = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMasterDropdown, setOpenMasterDropdown] = useState(false);
  const [openUnreDropdown, setOpenUnreDropdown] = useState(false);
  const [openUnre2BDropdown, setOpenUnre2BDropdown] = useState(false);
  const [openauditDropdown, setopenauditDropdown] = useState(false);
  const [matching, setMatching] = useState(false);

  const { role, loading } = useContext(AuthContext);
  const masterAllowedRoles = ['Admin', 'Accounts'];

  if (loading) return <p>Loading menus...</p>;

  const navItems = [
    { label: 'Upload Documents', path: '/upload', icon: <FaUpload />, roles: ['Admin', 'Accounts'] },

    { label: 'Process ITC & 2B', path: '/process_itc', icon: <FaFileExcel />, roles: ['Admin', 'Accounts'] },

    { label: 'ITC & 2B Mismatch', path: '/missmatchedreport', icon: <FaExchangeAlt />, roles: ['Admin', 'Accounts'] },
    { label: 'Reconciled', path: '/paidsummarypage', icon: <FaListAlt />, roles: ['Admin', 'Manager', 'Accounts'] },
    // { label: 'UnReconciled 2B', path: '/form2bmissinginv', icon: <FaListAlt />, roles: ['Admin', 'Manager', 'Accounts'] },
    { label: 'Debit Note Summary', path: '/debit_summary_page', icon: <FaListAlt />, roles: ['Admin', 'Accounts'] },
  ].filter(item => item.roles.includes(role));

  const masterDropdownItems = [
    { label: 'STATE', path: '/master/state', roles: ['Admin', 'Accounts'] },
    { label: 'GST', path: '/master/gst', roles: ['Admin', 'Accounts'] },
    { label: 'SUPPLIER TYPE', path: '/master/suppliertype', roles: ['Admin', 'Accounts'] },
    { label: 'Role', path: '/master/role', roles: ['Admin'] },
    { label: 'User', path: '/master/user', roles: ['Admin'] }
  ].filter(item => item.roles.includes(role));

  const unreconciledDropdownItems = [
    { label: 'UnReconciled ITC', path: '/pending_itc', roles: ['Admin', 'Accounts'] },
    { label: 'UnReconciled ITC Summary', path: '/summarypage', roles: ['Admin', 'Accounts'] }
  ].filter(item => item.roles.includes(role));

  const unreconciled2BDropdownItems = [
    { label: 'Invoicewise', path: '/pending_2B', roles: ['Admin', 'Accounts'] },
    { label: 'Summary', path: '/form2bmissinginv', roles: ['Admin', 'Accounts'] }
  ].filter(item => item.roles.includes(role));

  const auditlogDropdownItems = [
    { label: 'ITC Audit log', path: '/invoice_audit_log', roles: ['Admin', 'Accounts'] },
    { label: 'Form2B Audit log', path: '/form2b_audit_log', roles: ['Admin', 'Accounts'] }
  ].filter(item => item.roles.includes(role));

  const toggleMasterDropdown = () => setOpenMasterDropdown(prev => !prev);
  const toggleUnreDropdown = () => setOpenUnreDropdown(prev => !prev);
  const toggleUnre2BDropdown = () => setOpenUnre2BDropdown(prev => !prev);
  const toggleauditDropdown = () => setopenauditDropdown(prev => !prev);
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  return (
    <div>
      <nav style={styles.navbar}>
        <div style={styles.logoArea}>
          <span style={styles.logoText}>KJ GST Portal</span>
        </div>

        <div style={styles.navItems}>
          {navItems.map((item, idx) => (
            <button
              key={idx}
              onClick={() => navigate(item.path)}
              style={{
                ...styles.navButton,
                ...(location.pathname === item.path ? styles.activeButton : {})
              }}
            >
              {item.icon}
              <span style={styles.navLabel}>{item.label}</span>
            </button>
          ))}

          {['Admin', 'Accounts'].includes(role) && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleUnreDropdown}
                style={{
                  ...styles.navButton,
                  ...(unreconciledDropdownItems.some(i => i.path === location.pathname)
                    ? styles.activeButton
                    : {})
                }}
              >
                <FaListAlt />
                <span style={styles.navLabel}>UnReconciled ITC</span>
                <FaChevronDown style={{ marginLeft: '5px' }} />
              </button>
              {openUnreDropdown && (
                <div style={styles.dropdown}>
                  {unreconciledDropdownItems.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        navigate(item.path);
                        setOpenUnreDropdown(false);
                      }}
                      style={{
                        ...styles.dropdownItem,
                        ...(location.pathname === item.path ? styles.activeDropdownItem : {})
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {['Admin', 'Accounts'].includes(role) && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleUnre2BDropdown}
                style={{
                  ...styles.navButton,
                  ...(unreconciled2BDropdownItems.some(i => i.path === location.pathname)
                    ? styles.activeButton
                    : {})
                }}
              >
                <FaListAlt />
                <span style={styles.navLabel}>UnReconciled 2B</span>
                <FaChevronDown style={{ marginLeft: '5px' }} />
              </button>
              {openUnre2BDropdown && (
                <div style={styles.dropdown}>
                  {unreconciled2BDropdownItems.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        navigate(item.path);
                        setOpenUnre2BDropdown(false);
                      }}
                      style={{
                        ...styles.dropdownItem,
                        ...(location.pathname === item.path ? styles.activeDropdownItem : {})
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {['Admin', 'Accounts'].includes(role) && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleauditDropdown}
                style={{
                  ...styles.navButton,
                  ...(unreconciled2BDropdownItems.some(i => i.path === location.pathname)
                    ? styles.activeButton
                    : {})
                }}
              >
                <FaListAlt />
                <span style={styles.navLabel}>Audit Logs</span>
                <FaChevronDown style={{ marginLeft: '5px' }} />
              </button>
              {openauditDropdown && (
                <div style={styles.dropdown}>
                  {auditlogDropdownItems.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        navigate(item.path);
                        setopenauditDropdown(false);
                      }}
                      style={{
                        ...styles.dropdownItem,
                        ...(location.pathname === item.path ? styles.activeDropdownItem : {})
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {masterAllowedRoles.includes(role) && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleMasterDropdown}
                style={{
                  ...styles.navButton,
                  ...(masterDropdownItems.some(i => i.path === location.pathname)
                    ? styles.activeButton
                    : {})
                }}
              >
                <FaCog />
                <span style={styles.navLabel}>Master</span>
                <FaChevronDown style={{ marginLeft: '5px' }} />
              </button>
              {openMasterDropdown && (
                <div style={styles.dropdown}>
                  {masterDropdownItems.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        navigate(item.path);
                        setOpenMasterDropdown(false);
                      }}
                      style={{
                        ...styles.dropdownItem,
                        ...(location.pathname === item.path ? styles.activeDropdownItem : {})
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <button onClick={handleLogout} style={styles.logoutButton}>
          <FaSignOutAlt />
          Logout
        </button>
      </nav>

      <div style={styles.pageWrapper}>
        {children}
      </div>
    </div>
  );
};

const styles = {
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 30px',
    height: '64px',
    background: '#1f2937',
    color: '#fff',
    position: 'fixed',
    top: 0,
    width: '98%',
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0,0,0,0.15)'
  },
  logoArea: {
    display: 'flex',
    alignItems: 'center'
  },
  logoText: {
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '1px',
    color: '#ffffff'
  },
  navItems: {
    display: 'flex',
    gap: '14px',
    alignItems: 'center'
  },
  navButton: {
    background: 'transparent',
    border: 'none',
    color: '#cbd5e1',
    fontSize: '15px',
    fontWeight: '500',
    padding: '8px 14px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 0.3s, color 0.3s'
  },
  navLabel: {
    marginLeft: '8px',
    fontSize: '20px'
  },
  activeButton: {
    backgroundColor: '#374151',
    color: '#ffffff'
  },
  logoutButton: {
    backgroundColor: '#ef4444',
    border: 'none',
    color: '#fff',
    fontWeight: '500',
    fontSize: '20px',
    padding: '10px 18px',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  pageWrapper: {
    marginTop: '80px',
    padding: '30px',
    backgroundColor: '#f9fafb',
    minHeight: 'calc(100vh - 80px)'
  },
  dropdown: {
    position: 'absolute',
    top: '48px',
    background: '#fff',
    borderRadius: '6px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    minWidth: '180px',
    zIndex: 1001
  },
  dropdownItem: {
    padding: '10px 16px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#1f2937',
    backgroundColor: '#fff',
    cursor: 'pointer',
    borderBottom: '1px solid #e5e7eb'
  },
  activeDropdownItem: {
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold'
  },
  navButton: {
    background: 'transparent',
    border: 'none',
    color: '#cbd5e1',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '9px 16px',    
    borderRadius: '4px',       
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 0.3s, color 0.3s'
  },
  navLabel: {
    marginLeft: '6px',
    fontSize: '14px'           
  },
  
};

export default LayoutWithNavbar;
